export const MODAL_HEADER_TYPES = {
  searchHeader: 'searchHeader',
  textHeader: 'textHeader',
};
